import { Id } from "@dgs/core";
import { FC } from "react";
import { ApplicationForSidebarResource } from "../../shared/types/applicationForSidebar";
import { CarFleetTestDrivesLinks } from "../../shared/ui/CarFleetTestDrivesLinks";

interface Props {
	contactId: Id;
}

const getTestDriveLink = (contactId: Id, carFleet: ApplicationForSidebarResource) => {
	return `${carFleet.adminUrl}/contacts/${contactId}/test-drives`;
};

export const ContactTestDrivesLinks: FC<Props> = ({ contactId }) => {
	return <CarFleetTestDrivesLinks linkTo={(carFleet) => getTestDriveLink(contactId, carFleet)} />;
};
